import gsap from 'gsap';

export default function initSearchHeader() {
  const mq = window.matchMedia('(min-width: 1024px)');

  document.querySelectorAll('.search-header-form').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const searchWrap = form.querySelector('.search-wrap');
    const clearBtn = form.querySelector('.search-clear');
    const classExpanded = 'expanded';

    function setupDrop() {
      if (!searchWrap) return;
      if (mq.matches) {
        gsap.set(searchWrap, { clearProps: 'height,overflow' });
      } else {
        gsap.set(searchWrap, { height: 0, overflow: 'hidden' });
      }
    }

    setupDrop();
    mq.addEventListener('change', setupDrop);

    function updateClearBtn() {
      if (!clearBtn) return;
      clearBtn.classList.toggle('is-visible', !!(input.value && form.classList.contains(classExpanded)));
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        input.focus();
        updateClearBtn();
        form.submit();
      });
    }

    input.addEventListener('input', updateClearBtn);

    input.addEventListener('focus', () => {
      form.classList.add(classExpanded);
      updateClearBtn();
      if (!mq.matches && searchWrap) {
        gsap.killTweensOf(searchWrap);
        gsap.fromTo(searchWrap,
          { height: 0, overflow: 'hidden' },
          { height: 'auto', duration: 0.35, clearProps: 'height,overflow' }
        );
      }
    });

    form.addEventListener('focusout', (e) => {
      if (form.contains(e.relatedTarget)) return;
      form.classList.remove(classExpanded);
      if (clearBtn) clearBtn.classList.remove('is-visible');
      if (!mq.matches && searchWrap) {
        gsap.killTweensOf(searchWrap);
        gsap.set(searchWrap, { height: searchWrap.scrollHeight, overflow: 'hidden' });
        gsap.to(searchWrap, { height: 0, duration: 0.35 });
      }
    });
  });
}
